export const changeStatus = (status) => ({
    type: 'CHANGE_STATUS',
    payload: status,
  });
